import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal } from "../hooks/useReveal";
import { faqItems } from "../data/siteContent";

const FAQ = () => {
  return (
    <section className="bg-inkdeep py-24 sm:py-36" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
            <span className="h-px w-10 bg-gold/60" />
            Common Questions
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-cream tracking-tight leading-[1.06] mt-6">
            Before You Start, <em className="text-gold italic">Ask Away.</em>
          </h2>
        </Reveal>

        <Reveal className="mt-12 sm:mt-16">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="bg-surface border border-white/8 rounded-xl px-6 sm:px-8 data-[state=open]:border-gold/40 transition-colors duration-400"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger
                  className="font-display text-base sm:text-lg text-cream text-left hover:no-underline hover:text-gold py-6 [&>svg]:text-gold"
                  data-testid={`faq-trigger-${idx}`}
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-cream/65 text-sm sm:text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
